<template>
  <div v-if="modulesObject.length > 0 && loader === false">
    <app-collapse
      v-for="object in modulesObject"
      :key="object.id"
      accordion
    >
      <app-collapse-item
        v-if="object.module_id === 1 && object.depends_on === moduleObjectId"
        :title="object.module_settings.type === 1 ? 'Await Module: Time Based' : 'Await Module: Action Based'"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                <b-form-group
                  label="No. Of Days"
                  class="dropdownModuleFields w-100"
                  label-for="awaitType"
                  label-cols-md="12"
                >

                  <b-form-input
                    v-model="object.module_settings.number_of_days"
                    type="number"
                  />
                </b-form-group>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="(object.module_id === 2 || object.module_id === 14) && object.depends_on === moduleObjectId"
        title="Condition Module"
        class="nested-condition-module nested-module"
      >
        <b-list-group
          flush
          class="awaitlist"
        >
          <b-list-group-item>
            {{ $t('DEBTIA_CONDITION') }} : {{ getConditionStatement(object.module_settings.condition_id) }}
            <small
              v-if="object.module_settings.statements && object.module_settings.statements.length > 0"
            >
              ({{ object.module_settings.statements }})
            </small>
          </b-list-group-item>
          <b-list-group-item
            v-if="object.module_settings.condition_operator_id < 3"
          >
            {{ $t('DEBTIA_OPERATOR') }} : {{ object.module_settings.condition_operator_id === 1 ? $t('DEBTIA_TRUE_TEXT') : $t('DEBTIA_FALSE_TEXT') }}
          </b-list-group-item>
          <b-list-group-item
            v-else
          >
            {{ $t('DEBTIA_OPERATOR') }} : {{ getOperatorTitle(object.module_settings.operator) }}
          </b-list-group-item>
          <b-list-group-item
            v-if="object.module_settings.fields"
          >
            {{ object.module_settings.condition_id === 148 ? $t('DEBTIA_CLIENT_TYPE') : object.module_settings.fields[0].label }} : {{ object.module_settings.fields[0].value === 'person' ? 'Person' : object.module_settings.fields[0].value === 'sole-proprietorship' ? $t('DEBTIA_SOLE_PROPRIETORSHIP') : object.module_settings.fields[0].value === 'capital-company' ? $t('DEBTIA_CAPITAL_COMPANY') : object.module_settings.fields[0].value }}
          </b-list-group-item>
          <b-list-group-item
            v-if="object.module_settings.field"
          >
            {{ object.module_settings.field.label }} : {{ object.module_settings.condition_id === 10 ? $t(object.module_settings.field.value) : object.module_settings.field.value }}
          </b-list-group-item>
        </b-list-group>
        <b-button
          variant="relief-primary"
          class="expand-btn"
          @click="expandCondition(object.id)"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
            class="expand-feather"
          /> {{ $t('DEBTIA_EDIT') }}
        </b-button>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 25 && object.depends_on === moduleObjectId"
        title="Content Condition Module"
        class="nested-condition-module nested-module"
      >
        <b-list-group
          flush
          class="awaitlist"
        >
          <!-- <b-list-group-item
            v-if="object.module_settings.is_timed"
            class="main-items"
          >
            {{ $t('DEBTIA_TIMED') }} : {{ $t('DEBTIA_YES') }}
          </b-list-group-item> -->
          <b-list-group-item
            v-if="object.module_settings.is_timed && object.module_settings.days && object.module_settings.days !== null && object.module_settings.days !== ''"
            class="main-items"
          >
            {{ $t('DEBTIA_DAYS') }} : {{ object.module_settings.days }}
          </b-list-group-item>
          <!-- <b-list-group-item
            v-if="!object.module_settings.is_timed"
            class="main-items"
          >
            {{ $t('DEBTIA_TIMED') }} : {{ $t('DEBTIA_NO') }}
          </b-list-group-item> -->
          <template>
            <b-list-group-item
              v-for="(row, index) in object.module_settings.rules"
              :key="index"
              class="main-items"
            >
              {{ $t('DEBTIA_FILE_CATEGORIES') }}: {{ row.file_category }}
              | {{ $t('DEBTIA_OPERATOR') }}: {{ row.operator }}
              <!-- | {{ $t('DEBTIA_CUSTOM_FIELD') }}: {{ row.threshold }} -->
              <!-- <span v-if="row.value_type === 'literal'">
                | {{ $t('DEBTIA_NUMBER_OF_DAYS') }}: {{ row.threshold }}
              </span>
              <span v-if="row.value_type === 'custom_variable'">
                | {{ $t('DEBTIA_CUSTOM_VARIABLE') }}: {{ row.threshold }} ({{ $t('DEBTIA_CUSTOM_FIELD') }})
              </span> -->
              <span>
                | {{ $t('DEBTIA_NUMBER_OF_UPLOADS') }}: {{ row.threshold }}<span v-if="row.value_type === 'custom_variable'"> ({{ $t('DEBTIA_CUSTOM_FIELD') }})</span>
              </span>
            </b-list-group-item>
          </template>
        </b-list-group>
        <b-button
          variant="relief-primary"
          class="expand-btn"
          @click="expandCondition(object.id)"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
            class="expand-feather"
          /> {{ $t('DEBTIA_EXPAND') }}
        </b-button>
        <!-- <b-list-group
          flush
          class="awaitlist"
        >
          <b-list-group-item
            class="main-items"
          >
            <b-form-group
              class="awaitModuleFields mb-0"
              label-cols-md="4"
            >
              <b-form-checkbox
                :id="`checkbox-timed-${object.id}`"
                v-model="object.module_settings.is_timed"
                class="custom-control-primary"
              >
                {{ $t('DEBTIA_TIMED') }}
              </b-form-checkbox>
            </b-form-group>
          </b-list-group-item>

          <b-list-group-item
            v-if="object.module_settings.is_timed"
            class="main-items"
          >
            <b-form-group
              :label="$t('DEBTIA_DAYS')"
              :label-for="`days-input-${object.id}`"
              class="awaitModuleFields mb-0"
              label-cols-md="4"
            >
              <b-form-input
                :id="`days-input-${object.id}`"
                v-model="object.module_settings.days"
                type="number"
                min="0"
              />
            </b-form-group>
          </b-list-group-item>
          <b-list-group-item
            v-for="(row, index) in object.module_settings.rules"
            :key="index"
            class="main-items"
          >
            <b-form-group
              :label="$t('DEBTIA_FILE_CATEGORIES')"
              :label-for="`content-file-category-${object.id}-${index}`"
              class="awaitModuleFields mb-1"
              label-cols-md="4"
            >
              <v-select
                v-model="row.file_category"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sharedState.fileCategories.slice(1)"
                :reduce="val => val.value"
                :clearable="false"
                :input-id="`content-file-category-${object.id}-${index}`"
              />
            </b-form-group>

            <b-form-group
              :label="$t('DEBTIA_OPERATOR')"
              :label-for="`content-operator-${object.id}-${index}`"
              class="awaitModuleFields mb-1"
              label-cols-md="4"
            >
              <v-select
                v-model="row.operator"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="contentConditionOperatorOptions"
                :reduce="val => val.value"
                :clearable="false"
                :input-id="`content-operator-${object.id}-${index}`"
              />
            </b-form-group>

            <b-form-group
              :label="$t('Custom Field')"
              :label-for="`content-custom-field-${object.id}-${index}`"
              class="awaitModuleFields mb-1"
              label-cols-md="4"
            >
              <v-select
                v-model="row.threshold"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="customFieldsOptions"
                :reduce="val => val.value"
                :clearable="false"
                :input-id="`content-custom-field-${object.id}-${index}`"
              />
            </b-form-group>

            <b-form-group
              v-if="row.custom_field === 'literal'"
              label="Add Custom Number"
              :label-for="`content-literal-${object.id}-${index}`"
              class="awaitModuleFields mb-1"
              label-cols-md="4"
            >
              <b-form-input
                :id="`content-literal-${object.id}-${index}`"
                v-model="row.literal_value"
                type="number"
                min="0"
                placeholder="Number of days"
              />
            </b-form-group>
          </b-list-group-item>
        </b-list-group> -->
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 17 && object.depends_on === moduleObjectId"
        title="Bailiff Conclusion Popup"
        class="nested-condition-module nested-module"
      >
        <b-button
          variant="relief-primary"
          class="expand-btn"
          @click="expandCondition(object.id)"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
            class="expand-feather"
          /> {{ $t('DEBTIA_EXPAND') }}
        </b-button>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 3 && object.depends_on === moduleObjectId"
        title="Send Letter"
        class="nested-module"
      >
        <send-letter-or-email
          :id="`section-${object.id}`"
          :ref="`section-${object.id}`"
          :current-module="3"
          form-group-label="DEBTIA_LETTER_TEMPLATE_TEXT"
          :process-module="object"
          :letter-templates="sharedState.apiLetterData"
          :file-categories="sharedState.fileCategories"
          :special-options="sharedState.specialOptions"
          :template-variable-options="sharedState.templateVariableOptions"
          :client-id="sharedState.letterClient"
          :secret="sharedState.letterSecret"
          :contact-options="contactOptions"
          :email-templates="sharedState.apiEmailData"
          :prev-module-options="sharedState.prevModuleOptions"
          :payment-email-template="sharedState.paymentEmailTemplate"
        />
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 4 && object.depends_on === moduleObjectId"
        title="Send Email"
        class="nested-module"
      >
        <send-letter-or-email
          :id="`section-${object.id}`"
          :ref="`section-${object.id}`"
          :current-module="4"
          form-group-label="DEBTIA_EMAIL_TEMPLATE_TEXT"
          :process-module="object"
          :letter-templates="sharedState.apiLetterData"
          :file-categories="sharedState.fileCategories"
          :special-options="sharedState.specialOptions"
          :template-variable-options="sharedState.templateVariableOptions"
          :client-id="sharedState.emailClient"
          :secret="sharedState.emailSecret"
          :contact-options="contactOptions"
          :email-templates="sharedState.apiEmailData"
          :prev-module-options="sharedState.prevModuleOptions"
          :payment-email-template="sharedState.paymentEmailTemplate"
        />
      </app-collapse-item>
      <app-collapse-item
        v-if="(object.module_id === 5 || object.module_id === 6) && object.depends_on === moduleObjectId"
        :title="object.module_id === 5 ? 'Change State Module' : 'Action Module'"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                v-if="object.module_id === 5"
                class="internal-items"
              >
                <b-form-group
                  label="Process"
                  class="dropdownModuleFields w-100"
                  label-for="awaitType"
                  label-cols-md="12"
                >
                  <v-select
                    v-model="object.module_settings.new_process_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="processes"
                    :reduce="val => val.value"
                    :clearable="false"
                  />
                </b-form-group>
              </b-list-group-item>
              <b-list-group-item
                v-if="object.module_id === 6"
                class="internal-items"
              >
                Action: {{ getReason(object.module_settings.reason_id) }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <b-list-group
        v-if="object.module_id === 7 && object.depends_on === moduleObjectId"
        class="nested-module"
      >
        <b-list-group-item class="reminder-list-item">
          {{ 'Reminder Fee: '+object.module_settings.reminder_fee+' DKK' }}</b-list-group-item>
      </b-list-group>
      <app-collapse-item
        v-if="object.module_id === 8 && object.depends_on === moduleObjectId"
        title="Send Invoice Module"
        class="nested-condition-module nested-module"
      >
        <b-list-group
          flush
          class="awaitlist"
        >
          <b-list-group-item>
            {{ $t('DEBTIA_RECIPIENT') }} : {{ object.module_settings.recipient }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_AWAIT_PAYMENT ') }} : {{ object.module_settings.await_payment ? "True" : "False" }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_VATAMOUNT ') }} : {{ object.module_settings.vat_amount }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_SUBTOTAL ') }} : {{ object.module_settings.subtotal }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_TOTAL ') }} : {{ object.module_settings.total }}
          </b-list-group-item>
        </b-list-group>
        <h4>Products</h4>
        <b-table
          :items="object.module_settings.get_products"
          :fields="fields"
          striped
          responsive
          class="mb-0"
        >
          <template #cell(name)="row">
            {{ row.product_name }}
          </template>
          <template #cell(show_details)="row">

            <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
            <b-form-checkbox
              v-model="row.detailsShowing"
              @change="row.toggleDetails"
            >
              {{ row.detailsShowing ? $t('DEBTIA_HIDE') : $t('DEBTIA_SHOW') }}
            </b-form-checkbox>
          </template>

          <!-- full detail on click -->
          <template #row-details="row">
            <b-card>
              <b-row class="mb-2">
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>{{ $t('DEBTIA_QUANTITY') }} : </strong> {{ row.quantity }}
                </b-col>
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>{{ $t('DEBTIA_UNIT_PRICE') }} : </strong> {{ row.unit_price }}
                </b-col>
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>{{ $t('DEBTIA_TOTAL_PRICE') }} : </strong> {{ row.total_price }}
                </b-col>
              </b-row>
            </b-card>
          </template>

          <template #cell(avatar)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 9 && object.depends_on === moduleObjectId"
        title="User Action Module"
        class="nested-condition-module nested-module"
      >
        <b-list-group
          flush
          class="awaitlist"
        >
          <b-list-group-item>
            {{ $t('DEBTIA_DESCRIPTION') }} : {{ object.module_settings.description }}
          </b-list-group-item>
          <b-list-group-item
            v-if="object.module_settings.await"
          >
            {{ $t('DEBTIA_WAIT_FOR') }} : {{ object.module_settings.await_days }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_RECIPIENT') }} : {{ object.module_settings.recipient }}
          </b-list-group-item>
        </b-list-group>
        <b-button
          variant="relief-primary"
          class="expand-btn"
          @click="expandCondition(object.id)"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="16"
            class="expand-feather"
          /> {{ $t('DEBTIA_EXPAND') }}
        </b-button>
      </app-collapse-item>

      <app-collapse-item
        v-if="object.module_id === 10 && object.depends_on === moduleObjectId"
        title="Task List Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_TASK_LIST') }} : {{ object.module_settings.title }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>

      <b-list-group
        v-if="object.module_id === 11 && object.depends_on === moduleObjectId"
        class="nested-module"
      >
        <b-list-group-item class="reminder-list-item">
          A Compensation Fee of 310 per Invoice Document will be charged.
        </b-list-group-item>
      </b-list-group>

      <b-list-group
        v-if="object.module_id === 12 && object.depends_on === moduleObjectId"
        class="nested-module"
      >
        <b-list-group-item class="reminder-list-item">
          Collection Cost will be auto calculated.
        </b-list-group-item>
      </b-list-group>
      <b-list-group
        v-if="object.module_id === 13 && object.depends_on === moduleObjectId"
        class="nested-module"
      >
        <b-list-group-item class="reminder-list-item">
          {{ 'Collection Fee: '+object.module_settings.collection_fee+' DKK' }}</b-list-group-item>
      </b-list-group>
      <app-collapse-item
        v-if="object.module_id === 15 && object.depends_on === moduleObjectId"
        title="Custom Field Data Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                <b-row>
                  <b-col
                    v-for="variable in object.module_settings"
                    :key="variable.id"
                    cols="12"
                    md="12"
                    class="group-col"
                  >
                    <b-form-group
                      :label="$t(variable.label)"
                      label-for="h-first-name"
                      label-cols-md="12"
                      class="process-group"
                    >
                      <label>{{ variable.value === 'dato_felt' ? getDatoFelto(variable.functional_value) : variable.value }}</label>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 16 && object.depends_on === moduleObjectId"
        title="Change Termsheet Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_APPLY_TERMSHEET_TO') }} : {{ object.module_settings ? object.module_settings.termsheet_for : 'N/A' }}
              </b-list-group-item>
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_TERMSHEET') }} : {{ object.module_settings ? object.module_settings.termsheet : 'N/A' }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 18 && object.depends_on === moduleObjectId"
        title="Bailiff Case Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_OPERATOR') }} : {{ object.module_settings ?
                  object.module_settings.bailiff_status === 1 ? "True" : "False"
                  : 'N/A' }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 19 && object.depends_on === moduleObjectId"
        title="Transfer Court Fee Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ object.module_settings.court }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 20 && object.depends_on === moduleObjectId"
        title="Register Debtor RKI Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ object.module_settings.message }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 21 && object.depends_on === moduleObjectId"
        title="Delete Debtor RKI Module"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_REASON') }}: {{ getDebtiaReason(object.module_settings.reason) }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 22 && object.depends_on === moduleObjectId"
        title="Conclude Bailiff Process"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_BAILIFF_PROCESS') }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 23 && object.depends_on === moduleObjectId"
        title="Use Overvågning Termsheet"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item
                class="internal-items"
              >
                {{ $t('DEBTIA_DEFAULT_OVERVAGNING_TERMSHEET') }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 24 && object.depends_on === moduleObjectId"
        title="Await Till Date"
        class="nested-module"
      >
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <b-list-group
              flush
              class="awaitlist"
            >
              <b-list-group-item class="internal-items">
                {{ $t('DEBTIA_QUESTION') }}: {{ object.module_settings.question }}
              </b-list-group-item>
              <b-list-group-item class="internal-items">
                {{ $t('DEBTIA_DESCRIPTION') }}: {{ object.module_settings.description }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </app-collapse-item>
      <app-collapse-item
        v-if="object.module_id === 26 && object.depends_on === moduleObjectId"
        title="Deactivate Installment Plan Module"
        class="nested-module"
      >
        <b-list-group
          class="nested-module"
        >
          <b-list-group-item class="reminder-list-item">
            Active Installment Plan will be deactivated.
          </b-list-group-item>
        </b-list-group>
      </app-collapse-item>
    </app-collapse>
  </div>
  <div v-else>
    <app-collapse
      accordion
    >
      {{ $t('DEBTIA_NO_MODULE_MSG') }}
    </app-collapse>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BAlert, BListGroup, BListGroupItem, BFormGroup, BTable, BFormCheckbox, BFormInput,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'
import vSelect from 'vue-select'
// import i18n from '@/libs/i18n'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
// import AddModuleModal from './AddModuleModal.vue'
// import NumberInputType from './fields/NumberInputType.vue'
// import SelectField from './fields/SelectField.vue'
import SendLetterOrEmail from './SendLetterOrEmail.vue'

const DEBTIA_REASON_DESCRIPTIONS = {
  BET: 'Fordring betalt',
  AIN: 'Aftale indgået med skyldner',
  DØD: 'Skyldner er afgået ved døden',
  TFY: 'Tvangsakkord fyldestgjort',
  GAL: 'Gældssanering – al gæld bortfalder',
  VTT: 'Varen taget retur',
  TAF: 'Tvangsauktion aflyst',
  STR: 'Der er strid i sagen',
  DER: 'Andet – vi ønsker skyldner slettet',
}

export default {
  inject: ['sharedState'], // Inject the reactive shared state
  components: {
    BButton,
    BRow,
    BCol,
    BAlert,
    BListGroup,
    BListGroupItem,
    AppCollapse,
    AppCollapseItem,
    BFormGroup,
    BTable,
    BFormCheckbox,
    // NumberInputType,
    // SelectField,
    SendLetterOrEmail,
    vSelect,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  props: {
    contactOptions: {
      type: Array,
      required: true,
    },
    modulesObject: {
      type: Array,
      required: true,
    },
    moduleObjectId: {
      type: Number,
      required: true,
    },
    mainDivId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // conditionLoader: false,
      // previousObject: {},
      noObject: [],
      yesObject: [],
      allModules: [],
      stateNumber: 0,
      module: 0,
      modalLoaderOne: true,
      componentConditionCheck: false,
      conditionModule: true,
      processes: [],
      caseReasonOptions: [],
      fields: ['name', 'show_details'],
      userType: JSON.parse(localStorage.getItem('userData')).role[0],
      conditionOptions: [],
      loader: true,
      allOperator: [
        { label: 'True', value: 1 },
        { label: 'False', value: 2 },
        { label: 'Greater Than (>)', value: 7 },
        { label: 'Greater Than, Equal to (>=)', value: 9 },
        { label: 'Less Than (<)', value: 8 },
        { label: 'Less Than, Equal to (<=)', value: 10 },
        { label: 'Equal to (=)', value: 3 },
      ],
    }
  },
  watch: {
    state: {
      handler() {
        this.stateNumber = this.state
      },
    },
  },
  created() {
    this.getProcesses()
    this.getConditions()
    this.getCaseReasonOptions()
    EventBus.$on('changeCopyModuleTemplateVariable', obj => {
      if (obj.dependsOn > 0) this.getVariables(obj)
    })
  },
  methods: {
    getOperatorTitle(val) {
      const operator = this.allOperator.find(op => op.value === val)
      const label = operator ? operator.label : null
      return label
    },
    getVariables(obj) {
      EventBus.$emit('haltProcessCopyBtn', true)
      setTimeout(() => {
        this.$refs[obj.sectionID][0].changeTemplateVariables(obj.id)
      }, 500)
    },
    getAwaitBody(e) {
      const obj = {
        depends_on: e.depends_on,
        condition: e.condition,
        module_id: e.module_id,
        module_order: 1,
        number_of_days: e.module_settings.number_of_days,
        type: e.module_settings.type,
      }
      return obj
    },
    getChangeStateBody(e) {
      const obj = {
        depends_on: e.depends_on,
        condition: e.condition,
        module_id: e.module_id,
        module_order: 1,
        new_process_id: e.module_settings.new_process_id,
      }
      return obj
    },
    getNestedModules(type) {
      const arr = []
      this.modulesObject.forEach(element => {
        if (element.module_id === 3 || element.module_id === 4) {
          const obj = this.$refs[`section-${element.id}`][0].getTheObject(element.condition, element.depends_on)
          arr.push(obj)
        }
        if (element.module_id === 1) {
          const obj = this.getAwaitBody(element, type)
          arr.push(obj)
        }
        if (element.module_id === 5) {
          const obj = this.getChangeStateBody(element, type)
          arr.push(obj)
        }
        if (element.module_id === 2 || element.module_id === 14) {
          const obj = this.getConditionMainObject(element, type)
          arr.push(obj)
        }
      })
      return arr
    },
    getConditionMainObject(e, yesNo) {
      const conditionValue = e.module_settings.operator === 1 ? 1 : 0
      const toMake = {
        company_custom_var_id: 0,
        condition_id: e.module_settings.condition_id,
        condition_operator_id: e.module_settings.operator,
        // eslint-disable-next-line no-nested-ternary
        condition_value: e.module_settings.operator > 2 ? e.module_settings.condition_value > 0 ? e.module_settings.condition_value : 0 : Number(conditionValue),
        custom_option_id: e.module_settings?.optionValue ?? 0,
        custom_variable_id: e.module_settings?.CustomVarID ?? 0,
        custom_variable_value: e.module_settings?.customVariableValue ?? '',
        dacustom_variable_value: '',
        date_type: e.module_settings?.date_type ?? null,
        file_category_id: e.module_settings?.fileCategory ?? 0,
        group_id: e.module_settings?.CaseGroup ?? 0,
        interest_type_condition: e.module_settings?.interestType ?? '',
        module_id: e.module_id,
        module_order: 1,
        no_of_passengers: 0,
        sub_statements: e.module_settings?.statements ?? [],
        days: e.module_settings.no_of_days,
        condition: yesNo,
      }
      return toMake
    },
    async getProcesses() {
      const url = '/process/list?perPage=100000000&q=&page='
      await axios.get(url).then(response => {
        if (response.status) {
          const records = response.data.data.processes.data
          records.forEach(element => {
            const elementObj = { label: element.title, value: element.id }
            this.processes.push(elementObj)
          })
        }
      })
    },
    getConditionStatement(id) {
      const conditionTitle = this.conditionOptions.filter(element => element.value === id)
      return conditionTitle[0].label
    },
    expandCondition(id) {
      // this.conditionLoader = true
      // if (type === 2) {
      const obj = {
        btnId: id,
        main: this.mainDivId,
      }
      EventBus.$emit('expandDetailsInConditionModuleCopy', obj)
      // } else {
      // EventBus.$emit('expandDetailsInUserActionModule', id)
      // }
      // this.stateNumber += 1
      // setTimeout(() => {
      // const md = this.allModules
      // md.forEach(element => {
      //   if (element.id === id) {
      //     this.moduleObject = element
      //     if (this.moduleObject.depends_on === 0) {
      //       this.stateNumber = 0
      //     }
      //   }
      // })
      // this.getNoObject()
      // this.getYesObject()
      // this.conditionLoader = false
      // }, 3000)
    },
    getState(id) {
      let processTitle = ''
      processTitle = this.processes.filter(entry => entry.value === id)
      return processTitle[0].label
    },
    getReason(id) {
      let reasonTitle = ''
      reasonTitle = this.caseReasonOptions.filter(entry => entry.value === id)
      return reasonTitle[0].label
    },
    getDebtiaReason(code) {
      const description = DEBTIA_REASON_DESCRIPTIONS[code]
      return description ? `${code} - ${description}` : code
    },
    async getCaseReasonOptions() {
      const url = '/get-reason-options'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseReasonOptions = response.data.data
        }
      })
    },
    getDatoFelto(number) {
      // eslint-disable-next-line no-nested-ternary
      return Number(number) === 0 ? 'dags dato' : (Number(number) >= 1 ? `dags dato (+${number} dage)` : `dags dato (${number} dage)`)
    },
    async getConditions() {
      this.loader = true
      await axios.get('/process/get-conditions').then(response => {
        if (response.status === 200) {
          this.conditionOptions.push(...response.data.data.variables)
          this.loader = false
        }
      }).catch(error => console.log(error))
    },
  },
}
</script>

<style lang="scss">
.awaitlist {
  border-radius: 10px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  margin-bottom: 15px;
}

.row-yes-no {
  margin-top: 5px;
}

.yes-no {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}

.split-div .list-group-item.yes-no{
  background-color: #badcdc;
}

.split-div{
  border-radius: 5px;
  border-top: 2px solid #468783;
}

.yes-no:hover {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}
.list-group-item.main-items {
  text-align: center;
}

.condition-heading-title h4 {
  font-weight: 600;
  font-size: 1.1rem;
  color: inherit;
}

.collapse-icon.collapse-default .card .card-header {
  background-color: #f7f7f7;
}

.nested-condition-module {
  border: 1px solid #e4f2f1;
}

.nested-module {
  margin-bottom: 5px !important;
}

.expand-btn {
  width: 100%;
  margin-top: 10px;
}

.expand-feather {
  top: 0px !important;
}
.main-cols .alert .operator-list{
  position: relative;
  margin-bottom: 5rem;
  border-bottom: 2px solid #468783;
}

.list-group-item.internal-items {
  text-align: center;
}

.reminder-list-item {
  background-color: #f7f7f7;
}

</style>
